export default {"src":"/_next/static/media/logo-immomates.468a4b25.svg","height":39,"width":360,"blurWidth":0,"blurHeight":0};